
























































































import { Component, Vue } from "vue-property-decorator";
import List from "@/components/list.vue";
import LifetimeChanger from "@/components/lifetime-changer.vue";
import DashboardTemplate from "@/views/Layouts/dashboard-template.vue";
import { dateFormatter, resolve } from "@/utils/utils";
import DeviceInfo from "@/models/deviceInfo.model";
import { ActionTypes } from "@/store/devices/actions";

interface FilterOptions {
  text: string;
  value: string;
}

@Component({
  components: {
    DashboardTemplate,
    List,
    LifetimeChanger
  },
})
export default class Home extends Vue {
  private visible = false;
  private filterString = "";

  private get devices() {
    return this.$typedStore.state.device.devices;
  }

  private dateFormatter(row: any, column: any) {
    return dateFormatter(row, column);
  }

  private filterHandler(value: any, row: any, column: any) {
    return resolve(column.property, row) === value;
  }

  private async executeAction(device: DeviceInfo, action: ActionTypes, message: string) {
    if (await this.$typedStore.dispatch(action, device.id)) {
      alert(message);
    } else {
      alert("An error occurred. Please try again.");
    }
  }

  private async startRecovery(device: DeviceInfo) {
    await this.executeAction(device, ActionTypes.StartRecovery, "Device requested to be in recovery mode");
  }

  private async stopRecovery(device: DeviceInfo) {
    await this.executeAction(device, ActionTypes.StopRecovery, "Device requested to be in active mode");
  }

  private async startIdentification(device: DeviceInfo) {
    await this.executeAction(device, ActionTypes.StartIdentification, "Request sent to device to enable its identification through the Activator App");
  }

  private async stopIdentification(device: DeviceInfo) {
    await this.executeAction(device, ActionTypes.StopIdentification, "Request sent to device to disable its identification through the Activator App");
  }

  private async requestLocation(device: DeviceInfo) {
    await this.executeAction(device, ActionTypes.RequestLocation, "Request sent to the device report its location");
  }

  private async lifetimeChanged(device: DeviceInfo, lifetime: number) {
    const reportedLifetime = device?.status?.reported?.lifetime?.data;
    if (reportedLifetime !== lifetime * 365) {
      if (await this.$typedStore.dispatch(ActionTypes.ChangeLifetime, {device: device.id, lifetime})) {
        alert("Request sent to change the lifetime of the device");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  }

  private rowClick(val: DeviceInfo) {
    this.$router.push("/devices/" + val.id);
  }
}
